import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailSolution} from '../interfaces/icruise-detail-solution';
import {ICruiseDetailCabinByType} from '../interfaces/icruise-detail-cabin-by-type';
import uniqBy from '../../../../../utils/uniqBy';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'cruiseCabinsGroupedByType'
})
export class CruiseCabinsGroupedByTypePipe implements PipeTransform {

  transform(value: ICruiseDetailSolution[]): ICruiseDetailCabinByType[] {
    if (value) {
      // effettuo un ordinamento delle solutions per data di partenza piu vicina ed escludo poi, quelle che
      // non hanno alcun type impostato
      const solutionsSortedByDepartureDate = value
          .sort((a, b) => dayjs(a.departureDate).unix() - dayjs(b.departureDate).unix())
          .map((sol) => sol.cabinsGroupedByType) // recupero le cabine raggruppate per tipo
          .flat();

      // ritorno tutte le cabine raggruppate per tipo e con duplicati rimossi
      return uniqBy(solutionsSortedByDepartureDate, 'type');
    }

    return [];
  }

}
